module.exports = __webpack_public_path__ + "img/airpods.fdef4976.png";